import { SystemStyleObject } from '@aloft/toolkit-sui/chakra';

export function getRowStyles(
  isActive: boolean,
  isSelected: boolean,
  enableHoverStyle: boolean,
): SystemStyleObject {
  let backgroundColor: string | undefined = undefined;
  if (isSelected) backgroundColor = 'surface2';
  if (isActive) backgroundColor = 'selected4';

  return {
    td: {
      backgroundColor,
    },
    _hover: {
      td: {
        backgroundColor: isActive || !enableHoverStyle ? undefined : 'hover1',
      },
    },
  };
}
